module.exports = __webpack_public_path__ + "img/calendar.ca2553fc.svg";